import { ContactType } from '@/service/otpService';
import InputValidator from './inputValidator';

export const maskString = (str: string, type: ContactType): string => {
  if (type === 'phone') {
    let prefix = '';
    let start = '';
    if (str.startsWith('+39')) {
      prefix = '+39';
      start = str.substring(3, 6);
      if (str.length <= 6) return str;
      const masked = '*'.repeat(str.length - 6);
      return prefix + start + masked;
    } else {
      if (str.length <= 3) return str;
      start = str.substring(0, 3);
      const masked = '*'.repeat(str.length - 3);
      return start + masked;
    }
  } else if (type === 'email') {
    const atIndex = str.indexOf('@');
    if (atIndex === -1 || atIndex === 0) return str;

    const localPart = str.substring(0, atIndex);
    const domainPart = str.substring(atIndex);
    let maskedLocal: string;

    if (localPart.length <= 4) {
      maskedLocal = localPart.charAt(0) + '*'.repeat(localPart.length - 1);
    } else {
      maskedLocal = localPart.substring(0, 3) + '*'.repeat(localPart.length - 3);
    }

    return maskedLocal + domainPart;
  } else {
    return str;
  }
};

export { InputValidator };
